import React from 'react';

const ExpandMoreArrowDown = () => {
  return (
    <div className="expand-down-arrow">
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.59 0.295044L6 4.87504L1.41 0.295044L0 1.70504L6 7.70504L12 1.70504L10.59 0.295044Z" fill="#101316" />
      </svg>
    </div>
  );
};

export default ExpandMoreArrowDown;
